import { CircularProgress } from '@material-ui/core';
import React from 'react';
import styled from 'themed-components';

export interface LoadingWrapperProps {
	children: React.ReactElement | React.ReactElement[] | null;
	loading: boolean;
}

const Container = styled.div`
	display: flex;
	flex: 1;
	width: 100%;
	justify-content: center;
	align-items: center;
	height: 100%;
`;

export const LoadingWrapper = ({ children, loading }: LoadingWrapperProps) => {
	if (loading) {
		return (
			<Container>
				<CircularProgress />
			</Container>
		);
	}
	return <>{children}</>;
};
